<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-blue">
      <div class="card-icon">
        <md-icon>event_available</md-icon>
      </div>
      <h4 class="title">
        Booking Reference: <strong>{{ booking.id }}</strong>
      </h4>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-100" style="margin-bottom: 1em;">
          <span class="md-caption"
            >Booked On {{ booking.booking_date | formatDate }}</span
          >
        </div>

        <div class="md-layout-item md-size-5">
          <md-icon
            v-if="booking.departure.tour.type.value == 'tour'"
            class="md-primary"
            >public</md-icon
          >
          <md-icon v-else class="text-warning">event</md-icon>
        </div>
        <div class="md-layout-item md-size-30">
          <span class="md-subheading" v-if="booking.departure.tour"
            ><router-link
              :to="{
                name: 'Adventure Profile',
                params: { tour_id: booking.departure.tour.id }
              }"
              >{{ booking.departure.tour.title }}</router-link
            ></span
          >
          <span class="md-subheading" v-else>UNKNOWN</span>
        </div>

        <div class="md-layout-item md-size-5">
          <md-icon class="md-primary">flight_takeoff</md-icon>
          <md-tooltip md-direction="top">Departure</md-tooltip>
        </div>
        <div class="md-layout-item md-size-60">
          <span class="md-subheading"
            ><router-link
              v-if="booking.departure.tour"
              :to="{
                name: 'Departure Profile',
                params: {
                  tour_id: booking.departure.tour.id,
                  departure_id: booking.departure.id
                }
              }"
              >{{ booking.departure.start_date | formatDate }}</router-link
            >
            <span v-else>{{ booking.departure.start_date | formatDate }}</span>
            <span
              class="md-caption"
              :class="
                booking.departure.status.key == 'Confirmed'
                  ? 'text-success'
                  : 'text-danger'
              "
            >
              [{{ booking.departure.status.description }}]</span
            >
          </span>
          <div class="md-caption" v-if="booking.departure.tour">
            <a href="#" @click.stop="showDialog">
              Change
              <md-tooltip md-direction="top"
                >Change the Departure for this Booking</md-tooltip
              >
            </a>
          </div>
        </div>

        <div class="md-layout-item md-size-100">
          <md-switch v-model="booking.details_sent" @change="updateBooking"
            >Final Details Sent</md-switch
          >
        </div>
      </div>
    </md-card-content>

    <md-dialog :md-active.sync="showDepartureDialog" id="departure-list-dialog">
      <md-dialog-title>Available Departures</md-dialog-title>
      <md-dialog-content>
        <div class="md-layout">
          <md-table
            class="md-layout-item md-size-100"
            v-model="availableDepartures"
            md-card
            md-fixed-header
            :md-height="300"
            @md-selected="onSelect"
          >
            <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              md-selectable="single"
            >
              <md-table-cell md-label="Start Date">{{
                item.start_date | formatDate
              }}</md-table-cell>
              <md-table-cell md-label="Spaces">{{
                item.available_spaces
              }}</md-table-cell>
              <md-table-cell md-label="Status">{{
                item.status.description
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button
          class="md-primary md-dense"
          @click="showDepartureDialog = false"
          >Cancel</md-button
        >
        <md-button
          class="md-primary md-dense"
          @click="changeDeparture"
          :disabled="!selectedDeparture"
          >Change</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import tourApi from "@/services/api/tour";
import bookingApi from "@/services/api/booking";
import _filter from "lodash/filter";

export default {
  props: ["booking"],

  data() {
    return {
      departures: [],
      showDepartureDialog: false,
      selectedDeparture: null
    };
  },

  computed: {
    availableDepartures() {
      let currentDeparture = this.booking.departure?.id;
      return _filter(this.departures, function(departure) {
        return departure.id !== currentDeparture;
      });
    }
  },

  methods: {
    editTour() {},
    updateBooking() {
      bookingApi.updateBooking({
        id: this.booking.id,
        details_sent: this.booking.details_sent
      });
    },

    changeDeparture() {
      bookingApi
        .changeDeparture(this.booking, this.selectedDeparture)
        .then(response => {
          this.booking.departure = response.data.booking.departure;
          this.showDepartureDialog = false;
          this.$emit("bookingChanged", this.booking);
        });
    },

    showDialog() {
      this.selectedDeparture = null;
      this.showDepartureDialog = true;
    },

    onSelect(item) {
      this.selectedDeparture = item;
    }
  },

  mounted() {
    if (this.booking.departure.tour) {
      tourApi
        .getFutureDepartures(this.booking.departure.tour.id)
        .then(response => {
          this.departures = response.data.departures;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
#departure-list-dialog {
  &::v-deep .md-dialog-container {
    width: 768px;
  }
}
</style>
